module.exports = __webpack_public_path__ + "img/IMG_3346_2028_P_T_L_Black.17d49bb8.jpg";